module.exports = __webpack_public_path__ + "static/media/02.a26e4251.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/flight/volumetric/camera/02.png
// module id = 631
// module chunks = 0